import PropTypes from "prop-types";
import styles from "./Profile.module.scss";

const Profile = ({ user, open }) => {
  return (
    <a href="/my-spots" className={styles.button}>
      {user.firstName} {user.secondName}
    </a>
  );
};

Profile.propTypes = {
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  open: PropTypes.bool,
};

export default Profile;
